export default "__VITE_ASSET__$8_F7IMa__"